var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-icon mr-2"},[_c('div',{staticClass:"icon-container"},[_c('font-awesome-icon',{staticClass:"icon-element",attrs:{"icon":_vm.fileIcon,"fixed-width":""}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c41a5e6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-elements/file-icon.vue
// module id = 84
// module chunks = 0